import { Route, Routes, useNavigate } from 'react-router-dom'
import ProductNav from '../shared/ProductNav'
import OrderNav from '../shared/OrderNav'
import ClientNav from '../shared/ClientNav'
import ReviewNav from '../shared/ReviewNav'
import ShopLayout from '../../layouts/ShopLayout'
import { useAuth } from '@cabukaka/hooks'
import { Shop } from '@cabukaka/types'
import Loader from '../../components/ui/Loader'
import NewShopPage from '../../pages/shared-pages/shops/NewShopPage'
import ShopDetailsPage from '../../pages/shared-pages/shops/ShopDetailsPage'
import UpdateShopPage from '../../pages/shared-pages/shops/UpdateShopPage'
import SettingsNav from '../shared/SettingsNav'
import ShopDashboardPage from '../../pages/shop/ShopDashboardPage'


export default function ShopNav() {

    const { user, loading, logout } = useAuth()
    const navigate = useNavigate()
    const goToProfile = () => {
        navigate("/shop/settings")
    }

    const shop = user?.profile as Shop

    if (!user || loading) {

        return <Loader />
    }


    return (
        <ShopLayout
            onLogout={logout}
            onGotoProfile={goToProfile}
            shopData={shop}
            companyName={shop.name || user.username}
            email={user?.email}
            logoUrl={shop.logo}
        >
            <Routes>

                <Route path="/products/*" element={<ProductNav />} />
                <Route path="/orders/*" element={<OrderNav />} />
                <Route path="/clients/*" element={<ClientNav />} />
                <Route path="/reviews/*" element={<ReviewNav />} />
                <Route path="/create" element={<NewShopPage />} />
                <Route path="/details" element={<ShopDetailsPage />} />
                <Route path="/update" element={<UpdateShopPage />} />
                <Route path="/settings/*" element={<SettingsNav />} />
                <Route path="/overview" element={<ShopDashboardPage />} />

            </Routes>
        </ShopLayout>
    )
}
